.secondaryAction {
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: opacity 0.2s;
  opacity: 0.6;
}

.listItemButton {
  padding: 8px;
  background: transparent;
}

:global([data-keyboard-focused]) {
  background-color: var(--tuna-palette-action-selected);
}

/* Prevent double-hover: the parent ListItem handles the full-width
   hover highlight; the inner button should not add its own. */
.listItemButton.listItemButton:hover {
  background-color: transparent;
}
